import React, { ComponentType } from 'react';
import { WorkingHours } from 'store/workingHours/workingHours';
import useOrganizationStartWeekDay from 'hooks/useOrganizationStartWeekDay';
import {
  Scheduler,
  WeekView,
  Appointments,
  Toolbar,
} from '@devexpress/dx-react-scheduler-material-ui';
import { ViewState } from '@devexpress/dx-react-scheduler';
import TimeScaleTickCellComponent from 'components/BookProperties/BookingForm/MinutesBookingScheduler/WeekView/TimeScaleTickCellComponent/TimeScaleTickCellComponent';
import useScrollCalendar from 'hooks/useScrollCalendar';
import convertToScheduleWorkingHours from './convertToScheduleWorkingHours';
import AppointmentContainerComponent from './libComponents/AppointmentContainerComponent';
import TimeScaleLabelComponent from './libComponents/TimeScaleLabelComponent';
import TimeTableCellComponent from './libComponents/TimeTableCellComponent';
import AppointmentContentComponent from './libComponents/AppointmentContentComponent/AppointmentContentComponent';
import StyledSchedulerWrapper from './SchedulerWrapper.styled';
import ScheduleNavigator from './libComponents/ScheduleNavigator/ScheduleNavigator';
import DayScaleCellComponent from './libComponents/DayScaleCellComponent/DayScaleCellComponent';
import ScheduleSummary from './ScheduleSummary/ScheduleSummary';
import useScheduleCalendarContext from './context/useScheduleCalendarContext';

interface ScheduleCalendarProps {
  workingHours: WorkingHours[];
  earliestScheduleShift: number;
}

export default function ScheduleCalendar({
  workingHours,
  earliestScheduleShift,
}: ScheduleCalendarProps) {
  const { currentDate, draftScheduleWorkingHours } =
    useScheduleCalendarContext();

  const schedulerWrapperRef = useScrollCalendar({
    scrollHour: earliestScheduleShift,
  });
  const startWeekDay = useOrganizationStartWeekDay();

  const scheduleWorkingHours = draftScheduleWorkingHours
    ? [
        ...convertToScheduleWorkingHours(workingHours),
        draftScheduleWorkingHours,
      ]
    : convertToScheduleWorkingHours(workingHours);

  return (
    <>
      <StyledSchedulerWrapper
        ref={schedulerWrapperRef}
        className="scheduler-wrapper"
      >
        <Scheduler
          data={scheduleWorkingHours}
          firstDayOfWeek={startWeekDay}
          height="auto"
        >
          <ViewState currentDate={currentDate} />
          <WeekView
            dayScaleCellComponent={DayScaleCellComponent}
            timeTableCellComponent={TimeTableCellComponent}
            timeScaleTickCellComponent={TimeScaleTickCellComponent}
            timeScaleLabelComponent={TimeScaleLabelComponent}
            cellDuration={60}
          />
          <Toolbar flexibleSpaceComponent={ScheduleNavigator} />
          <Appointments
            appointmentContentComponent={
              AppointmentContentComponent as ComponentType<Appointments.AppointmentContentProps>
            }
            containerComponent={
              AppointmentContainerComponent as ComponentType<Appointments.ContainerProps>
            }
          />
        </Scheduler>
      </StyledSchedulerWrapper>
      <ScheduleSummary
        workingHours={workingHours}
        startWeekDay={startWeekDay}
      />
    </>
  );
}
